import { render } from "./Profile-Others.vue?vue&type=template&id=9032195e"
import script from "./Profile-Others.vue?vue&type=script&lang=js"
export * from "./Profile-Others.vue?vue&type=script&lang=js"

import "./Profile-Others.vue?vue&type=style&index=0&id=9032195e&lang=less"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\spiel26-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__